import { Link, NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const NavItem = ({ to, children, testid }) => (
  <NavLink
    to={to}
    data-testid={testid}
    className={({ isActive }) =>
      `font-mono text-base font-bold uppercase tracking-[0.22em] transition-colors ${
        isActive ? "text-[#A855F7]" : "text-[#A1A1AA] hover:text-[#FAFAFA]"
      }`
    }
  >
    {children}
  </NavLink>
);

const Navbar = () => {
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-40 border-b border-white/5 backdrop-blur-md" style={{ background: "rgba(5,5,5,0.7)" }}>
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-4 py-4 sm:px-6">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center border border-[#A855F7] bg-[#A855F7] text-black">
            <span className="font-[Unbounded,sans-serif] text-lg font-bold leading-none">B</span>
          </div>
          <div>
            <div className="font-[Unbounded,sans-serif] text-lg font-bold uppercase tracking-[0.18em] text-[#FAFAFA]">
              Black Box Radio
            </div>
            <div className="font-mono text-xs font-bold uppercase tracking-[0.36em] text-[#A1A1AA]">Free Radio / Original Music</div>
          </div>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          <NavItem to="/" testid="nav-live">Live</NavItem>
          <a href="#schedule" data-testid="nav-schedule" className="font-mono text-base font-bold uppercase tracking-[0.22em] text-[#A1A1AA] transition-colors hover:text-[#FAFAFA]">Schedule</a>
          <a href="#featured" data-testid="nav-featured" className="font-mono text-base font-bold uppercase tracking-[0.22em] text-[#A1A1AA] transition-colors hover:text-[#FAFAFA]">Featured</a>
          <a href="#about" data-testid="nav-about" className="font-mono text-base font-bold uppercase tracking-[0.22em] text-[#A1A1AA] transition-colors hover:text-[#FAFAFA]">About</a>
          {user ? (
            <NavItem to="/admin" testid="nav-admin">Admin</NavItem>
          ) : null}
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
